import { icons } from "@patient-watch/icons";
import { commonComponents as cc } from "@/components/common";
import useNextFootWatchPage from "@/features/foot-watch/hooks/useNextFootWatchPage";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { capitaliseSentence } from "@/services/capitaliseSentence";

const PrepForTop = () => {
    const { angle, side, diaryId } = Route.useParams();
    const routeContext = Route.useRouteContext();
    const typedAngle = routeContext?.angle || (angle as "top" | "sole");
    const typedSide = routeContext?.side || (side as "left" | "right");
    const { navigateNext } = useNextFootWatchPage(diaryId, "instruction", typedAngle, typedSide);

    return (
        <div className="flex-col justify-between items-stretch content-between mx-auto px-2 w-full h-full">
            <cc.Title words={capitaliseSentence(typedAngle + " " + typedSide)} />
            <div className="flex-col justify-center mx-auto mt-4 mb-6 w-[50vw] max-w-[250px]">
                {typedAngle === "top" ? <icons.TopOfFootDrawing /> : <icons.SoleOfFootDrawing />}
            </div>
            {typedAngle === "top" ? (
                <ol className="flex flex-col mx-auto px-8 py-4 font-medium text-xl list-decimal">
                    <li className="mb-4">Sit at a table in a well lit room and remove shoes and socks.</li>
                    <li className="mb-4">Press 'next' to start the timer.</li>
                    <li className="">Point the camera at your foot and wait for the photo to be taken.</li>
                </ol>
            ) : (
                <ol className="flex flex-col mx-auto px-8 py-4 font-medium text-xl list-decimal">
                    <li className="mb-4">Press "next" to start the timer.</li>
                    <li className="mb-4">Place your phone screen-up on the floor under the table.</li>
                    <li className="mb-0">
                        Position your foot in frame, keeping your face out of the photo, and wait for the photo to be
                        taken.
                    </li>
                </ol>
            )}

            <cc.FooterButtons
                func1={() => navigateNext()}
                words1="Next"
                icon1={
                    <div className="flex justify-center items-center ml-[2px] p-[6px] w-8 h-8 rotate-180">
                        <icons.BackArrow fill="white" />
                    </div>
                }
            />
        </div>
    );
};

export const Route = createFileRoute("/_app/foot-watch/$diaryId/new/instructions/$angle/$side")({
    component: PrepForTop,
    validateSearch: z.object({
        angle: z.enum(["top", "sole"]).optional(),
        side: z.enum(["left", "right"]).optional(),
    }),
    beforeLoad: ({ params }) => {
        // Validate and cast params
        const angle = params.angle === "top" || params.angle === "sole" ? params.angle : "top";
        const side = params.side === "left" || params.side === "right" ? params.side : "left";
        return {
            angle: angle as "top" | "sole",
            side: side as "left" | "right",
        };
    },
});
